
// @ts-nocheck
import locale_en_46json_d19f9d09 from "#nuxt-i18n/d19f9d09";
import locale_es_46json_db31d814 from "#nuxt-i18n/db31d814";

export const localeCodes =  [
  "en",
  "es"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_d19f9d09",
      load: () => Promise.resolve(locale_en_46json_d19f9d09),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_db31d814",
      load: () => Promise.resolve(locale_es_46json_db31d814),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      files: [
        {
          path: "/home/vsts/work/1/s/packages/admin-dashboard/lang/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      files: [
        {
          path: "/home/vsts/work/1/s/packages/admin-dashboard/lang/es.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "./lang",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    files: [
      {
        path: "/home/vsts/work/1/s/packages/admin-dashboard/lang/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    files: [
      {
        path: "/home/vsts/work/1/s/packages/admin-dashboard/lang/es.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/